import { render, staticRenderFns } from "./GoodsClass.vue?vue&type=template&id=12071fb8&"
import script from "./GoodsClass.vue?vue&type=script&lang=js&"
export * from "./GoodsClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports